module.exports = __webpack_public_path__ + "static/media/logo.ce7d5f2b.png";